import Choice, { ChoiceItem } from '@ingka/choice';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ConditionalRender from '../../../components/ConditionalRender';
import {
  getRegisteredTimeSlotAndState,
  getSelectedTimeslot,
  useAppContext,
} from '../../../contextProviders/AppContext';
import { TimeSlot } from '../../../types/model';
import { formatEventTimeSpan } from '../../../utils/formatDate';
import getCaption from './getCaption';
import { isPassedTimeSlot } from '../../../contextProviders/AppContext/utils';

type PropsType = {
  timeSlots: Array<TimeSlot>;
  onSelect: any;
  timeZone: string;
};

const StyledChoice = styled(Choice)`
  display: grid;
  row-gap: var(--space-100);
  > li {
    margin: 0;
  }
  ${({ theme }) => `${theme.breakpoints.lg} {
    row-gap: var(--space-150);
    column-gap: var(--space-150);
    grid-template-columns: auto auto;
  }`}
`;

const Title = styled.p`
  font-weight: bold;
  margin: 0;
`;

const Selectable = ({ timeSlots, onSelect, timeZone }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const [registeredToTimeSlot, registrationState] = useSelector(
    getRegisteredTimeSlotAndState
  );
  const selectedTimeslot = useSelector(getSelectedTimeslot);

  const selectedIndex = timeSlots.findIndex(
    (t) => t.timeslotId === selectedTimeslot?.timeslotId
  );

  return (
    <ConditionalRender predicate={selectedIndex > -1}>
      <Title>{t('event.chooseDate')}</Title>
      <StyledChoice onSelect={onSelect} preselectedIndex={selectedIndex}>
        {timeSlots.map((timeSlot: TimeSlot, i: number) => (
          <ChoiceItem
            key={i}
            id={timeSlot.timeslotId}
            title={formatEventTimeSpan(
              timeSlot.utcStartDate,
              timeSlot.utcEndDate,
              timeSlot.startDate,
              timeSlot.endDate,
              timeZone
            )}
            caption={getCaption(
              timeSlot,
              registeredToTimeSlot,
              registrationState,
              t
            )}
            disabled={
              isPassedTimeSlot(timeSlot) ||
              (registeredToTimeSlot &&
                registeredToTimeSlot !== timeSlot.timeslotId)
            }
          />
        ))}
      </StyledChoice>
    </ConditionalRender>
  );
};

export default Selectable;
